import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from '../../AppRoutes';
import { Icon } from '../../components';

export interface IFranchiseWraperProps {}

export const withFranchiseWraper =
  (Component: FC<IFranchiseWraperProps>) => (props: IFranchiseWraperProps) => {
    return (
      <div className='withFranchiseWraper'>
        <div className='TabLinks'>
          <NavLink to={Routes.franchiseTable.path}>
            <Icon.Table />
            Table
          </NavLink>

          <NavLink to={Routes.franchiseTree.path}>
            <Icon.Tree />
            Tree
          </NavLink>

          <NavLink to={Routes.franchiseLevelSettingHistory.path}>
            <Icon.HistoryIcon />
            Level Setting History
          </NavLink>

          <NavLink to={Routes.franchiseCommissionHistory.path}>
            <Icon.HistoryIcon />
            Commission History
          </NavLink>

          {/* <NavLink to={Routes.franchiseLeader.path} >
                    <Icon.Leader />

                    Leader
                </NavLink> */}
        </div>

        <Component {...props} />
      </div>
    );
  };
